import React from 'react';
import { StudyDataFilterContextProvider } from '@contexts-clean/study-data-filter-context';
import StudyFilterPage from '@pages-clean/dummy-page/pages/screen-filter-page';

const FiltersPage = () => {
    return (
        <StudyDataFilterContextProvider>
            <StudyFilterPage />
        </StudyDataFilterContextProvider>
    );
};

export default FiltersPage;
